
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[series]",
      function () {
        return require("private-next-pages/series/[series]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[series]"])
      });
    }
  